import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const FileIconContainer = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: ${({ theme }) => theme.palette.grey[100]};
`;

export const UploadContainer = styled.div<{ $dragActive: boolean }>`
  gap: 8px;
  display: flex;
  padding: 20px;
  margin: 10px 0;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  border: 1px dashed ${({ theme }) => theme.palette.primary.main};
  background: ${({ $dragActive, theme }) => ($dragActive ? theme.tint.primary.subtle : theme.palette.common.white)};

  h1 {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.17px;
  }
`;

export const UploadButton = styled.button`
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 16px;
  font-weight: 700;
`;

export const FileContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin: 10px 0;
  padding: 10px 20px;
  justify-content: space-between;
`;

export const FileName = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
  margin: 0;
`;

export const FileData = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
  margin: 0;
`;

export const EmptyState = styled.p`
  margin: 0;
  padding: 40px 20px;
  text-align: center;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
  line-height: 143%;
  letter-spacing: 0.17px;
`;

/** Audits only: the record has no outer card, so the tab paints the white panel the legacy record's did. */
export const AttachmentsPanel = styled.div`
  padding: 16px;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.common.white};
`;
